import { IPresenterProps } from './types';
import * as S from './styles';
import SearchBar from '../../components/SearchBar/Container';
import { useHistory } from "react-router-dom";
import { useMediaQuery } from '../../utils/CustomHooks/MediaQuery';
import { useTheme } from 'styled-components';
import { Menu, X, User } from 'lucide-react';

const NavbarPresenter = (props: IPresenterProps) => {
    const theme = useTheme();
    const history = useHistory();
    let matches = useMediaQuery(`(min-width: ${theme.screenSizes.tablet})`);

    // Navigation handlers
    const handleLoginClick = () => {
        history.push('/login');
    };

    const handleBusinessClick = () => {
        history.push('/businessRegistration');
    };

    const handleProfileClick = () => {
        if (props.closeProfileDropdown) {
            props.closeProfileDropdown();
        }
        history.push('/profile');
    };

    const handleMobileMenuItemClick = (path: string) => {
        if (props.toggleMobileMenu) {
            props.toggleMobileMenu();
        }
        history.push(path);
    };

    const renderNavbar = () => {
        if (!props.isSearchBarHidden && matches) {
            // Always show full SearchBar (same as Home page)
            return (
                <SearchBar
                    isBtnDisabled={props.isBtnDisabled ?? false}
                    formData={props.formData ?? { business: '', date: '', location: '' }}
                    onChange={props.onChange ?? (() => {})}
                    searchResults={props.searchResults ?? []}
                    searchBusinessCategories={props.searchBusinessCategories ?? (() => {})}
                    isCategoriesBoxVisible={props.isCategoriesBoxVisible ?? false}
                    toggleCategoriesBoxVisibility={props.toggleCategoriesBoxVisibility ?? (() => {})}
                    addCategory={props.addCategory ?? (() => {})}
                    selectedCategories={props.selectedCategories ?? []}
                    removeCategory={props.removeCategory ?? (() => {})}
                    isDatePickerVisible={props.isDatePickerVisible ?? false}
                    toggleDatePickerVisibility={props.toggleDatePickerVisibility ?? (() => {})}
                    selectedDate={props.selectedDate}
                    handleSelectDate={props.handleSelectDate ?? (() => {})}
                    isLocationBoxVisible={props.isLocationBoxVisible ?? false}
                    toggleLocationBoxVisibility={props.toggleLocationBoxVisibility ?? (() => {})}
                    searchLocations={props.searchLocations ?? (() => {})}
                    searchHoodResults={props.searchHoodResults ?? []}
                    selectLocation={props.selectLocation ?? (() => {})}
                />
            );
        }
    }

    return (
        <S.NavBar>
            <S.NavBarContainer navWidth={props.navWidth}>
                <S.FlexRow>
                    <S.LogoContainer to="/" style={{ textDecoration: 'none' }}>
                        <S.TitleMain>MORA</S.TitleMain>
                    </S.LogoContainer>
                </S.FlexRow>

                <S.FlexRow style={{ justifyContent: 'center' }}>
                    {renderNavbar()}
                </S.FlexRow>

                <S.FlexRow style={{ justifyContent: 'flex-end' }}>
                    <S.NavRight>
                        {props.authUser ? (
                            <S.ProfileContainer ref={props.profileDropdownRef}>
                                <S.ProfileButton onClick={props.toggleProfileDropdown}>
                                    <User size={20} />
                                </S.ProfileButton>
                                {props.profileDropdownOpen && (
                                    <S.ProfileDropdown>
                                        <S.DropdownItem onClick={handleProfileClick}>
                                            Mi Perfil
                                        </S.DropdownItem>
                                        <S.DropdownDivider />
                                        <S.DropdownItem onClick={handleBusinessClick}>
                                            Mora para Negocios
                                        </S.DropdownItem>
                                        <S.DropdownDivider />
                                        <S.DropdownItem onClick={props.onLogout}>
                                            Cerrar Sesión
                                        </S.DropdownItem>
                                    </S.ProfileDropdown>
                                )}
                            </S.ProfileContainer>
                        ) : (
                            <>
                                <S.LoginButton onClick={handleLoginClick}>
                                    Iniciar Sesión
                                </S.LoginButton>
                                <S.BusinessButton onClick={handleBusinessClick}>
                                    Mora para Negocios
                                </S.BusinessButton>
                            </>
                        )}
                    </S.NavRight>

                    <S.MobileMenuButton onClick={props.toggleMobileMenu}>
                        {props.mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </S.MobileMenuButton>
                </S.FlexRow>

            </S.NavBarContainer>

            {props.mobileMenuOpen && (
                <S.MobileMenu ref={props.mobileMenuRef}>
                    {props.authUser ? (
                        <>
                            <S.MobileMenuItem>
                                Hola, {props.authUser.email.split('@')[0] || 'Usuario'}
                            </S.MobileMenuItem>
                            <S.MobileMenuItem onClick={() => handleMobileMenuItemClick('/profile')}>
                                Mi Perfil
                            </S.MobileMenuItem>
                            <S.MobileMenuItem onClick={props.onLogout}>
                                Cerrar Sesión
                            </S.MobileMenuItem>
                        </>
                    ) : (
                        <S.MobileMenuItem onClick={() => handleMobileMenuItemClick('/login')}>
                            Iniciar Sesión
                        </S.MobileMenuItem>
                    )}
                    <S.MobileMenuItem onClick={() => handleMobileMenuItemClick('/businessRegistration')}>
                        Mora para Negocios
                    </S.MobileMenuItem>
                </S.MobileMenu>
            )}
        </S.NavBar>
    )
};

export default NavbarPresenter;